export enum ScheduledJobType {
    SystemRestart = 0,
    ServiceRestart = 1,
    SensorReset = 2,
    CustomScript = 3,
    RestartHmiDevice = 5,
    RestartBiometricDevice = 6,
};

export const SCHEDULED_JOB_TYPE_LABELS: { [key in ScheduledJobType]: string } = {
    [ScheduledJobType.SystemRestart]: "System Restart",
    [ScheduledJobType.ServiceRestart]: "Service Restart",
    [ScheduledJobType.SensorReset]: "Sensor Reset",
    [ScheduledJobType.CustomScript]: "Custom Script",
    [ScheduledJobType.RestartHmiDevice]: "Restart HMI Device",
    [ScheduledJobType.RestartBiometricDevice]: "Restart Biometric Device",
};

export const SCHEDULED_UNIQUE_JOB_TYPES = [
    ScheduledJobType.SensorReset,
    ScheduledJobType.ServiceRestart,
    ScheduledJobType.SystemRestart,
    ScheduledJobType.RestartHmiDevice,
    ScheduledJobType.RestartBiometricDevice,
];

export const SCHEDULED_REUSABLE_JOB_TYPES = [
    ScheduledJobType.CustomScript,
];
